import {
    DEMAND_SPECIFIC_EDIT_REQUEST,
    DEMAND_SPECIFIC_EDIT_SUCCESS,
    DEMAND_SPECIFIC_EDIT_FAIL,
    DEMAND_SPECIFIC_EDIT_RESET,
    DEMAND_BATCH_EDIT_REQUEST,
    DEMAND_BATCH_EDIT_SUCCESS,
    DEMAND_BATCH_EDIT_FAIL,
    DEMAND_BATCH_EDIT_RESET,
} from '../constants/demandEditConstants.js';

/**
 * Reducer for specific demand notice edit operations
 */
export const demandSpecificEditReducer = (state = {}, action) => {
    switch (action.type) {
        case DEMAND_SPECIFIC_EDIT_REQUEST:
            return { loading: true };
        case DEMAND_SPECIFIC_EDIT_SUCCESS:
            return { loading: false, success: true, demand_edit: action.payload };
        case DEMAND_SPECIFIC_EDIT_FAIL:
            return { loading: false, error: action.payload };
        case DEMAND_SPECIFIC_EDIT_RESET:
            return {};
        default:
            return state;
    }
};

/**
 * Reducer for batch demand notice edit operations
 */
export const demandBatchEditReducer = (state = {}, action) => {
    switch (action.type) {
        case DEMAND_BATCH_EDIT_REQUEST:
            return { loading: true };
        case DEMAND_BATCH_EDIT_SUCCESS:
            return { loading: false, success: true, demand_edit: action.payload };
        case DEMAND_BATCH_EDIT_FAIL:
            return { loading: false, error: action.payload };
        case DEMAND_BATCH_EDIT_RESET:
            return {};
        default:
            return state;
    }
};
